var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.getClasses,attrs:{"id":"app"}},[_c('Header'),_c('div',{staticClass:"content"},[_c('transition',{attrs:{"name":"fade","mode":"out-in"}},[_c('router-view')],1),_c('Help'),_c('FullscreenContainer')],1),_c('Footer')],1)}
var staticRenderFns = []

export { render, staticRenderFns }